import React, { useState } from "react";
import PropTypes from "prop-types";
import {
	MDBContainer,
	MDBIcon,
	MDBModal,
	MDBModalHeader,
	MDBModalBody,
} from "mdbreact";

const textoExtravestibular =
	"Completou seu curso de graduação, está cursando ou deixou de cursar? Sem problemas! Aqui na Feevale, você pode ingressar em nossos cursos com o extravestibular, por meio de transferência, reingresso e como portador de diploma. Em caso de ainda sobrarem vagas, podemos abrir um novo processo seletivo e você ganha uma nova chance para se inscrever.";

const textosExtra = {
	medicina:
		"Este processo seletivo é destinado aos candidatos que estão vinculados a um curso de Medicina em outra Instituição de Ensino Superior no Brasil e que desejam continuar seus estudos no curso de Medicina da Universidade Feevale e, também, para alunos graduados no Brasil em outros cursos de bacharelados da área da saúde.",
	transferencia:
		"Venha para a Feevale! Se você é acadêmico de outra Instituição de Ensino Superior e deseja estudar na Universidade Feevale, solicite sua transferência.",
	portador:
		"Já é graduado em algum curso superior e pretende cursar uma nova graduação? Ingresse na Universidade Feevale como Portador de Diploma.",
	reingresso:
		"Se você por algum motivo ficou afastado da graduação e agora quer retornar aos estudos e à vida acadêmica, faça sua solicitação de reingresso*.\n\n*Lembramos que não é possível o reingresso para cursos em extinção.\n\nAluno PROUNI: Caso você já tenha sido aluno bolsista Prouni anteriormente, ao solicitar o reingresso ou reingresso com troca de curso, turno ou modalidade, você se tornará um aluno pagante. Caso desejar reingressar com Bolsa Prouni, é necessário consultar o setor de Núcleo de Apoio ao Estudante por meio do site Apoio ao Estudante ou e-mail prouni@feevale.br para verificar esta possibilidade.",
	troca:
		"Se deseja migrar para outra graduação, solicite a Troca de Curso. Caso o seu curso tenha mais de um turno, é possível realizar a solicitação de troca de turno, ou ainda, trocar de modalidade.\n\nAluno PROUNI: Caso você seja aluno bolsista Prouni, indicamos que antes de realizar a solicitação de troca de curso, turno ou modalidade, consulte o setor de Núcleo de Apoio ao Estudante por meio do site Apoio ao Estudante ou e-mail prouni@feevale.br para verificar a possibilidade desta troca.\n\nSalientamos que não deverá ser realizada qualquer alteração da matrícula sem autorização do Núcleo de Apoio ao Estudante, uma vez que a troca poderá acarretar a perda da bolsa.",
};

const dadosModalidade = {
	presencial: {
		rotulo: "PRESENCIAL",
		titulo: "Escolha sua forma de ingresso",
		descricao:
			"Veja as opções para cursos presenciais e semipresenciais da Feevale.",
		graduacao: {
			titulo: "Vestibular",
			resumo:
				"Processo seletivo para cursos presenciais e semipresenciais.",
			textoCompleto:
				"Para ingressar, você pode fazer a redação online ou presencial, usar suas notas da redação e prova objetiva do Enem, e ainda aproveitar as notas de outros processos seletivos que fez aqui.",
			acoes: [
				{
					label: "Inscreva-se",
					href: "https://ingresso.feevale.br/?idcategoriaps=17,29",
					principal: true,
				},
				{
					label: "Ver edital",
					href:
						"https://editais.feevale.br/editais/processo-seletivo-vestibular-para-cursos-presenciais-e-semipresenciais-202701/",
				},
			],
			medicina: {
				titulo: "Processo seletivo da Medicina",
				textoCompleto:
					"O processo seletivo é feito com redação e prova objetiva presencial. Você também pode usar as notas da redação e prova objetiva do Enem.",
				href: "https://ingresso.feevale.br/medicina/login",
				editalHref:
					"https://editais.feevale.br/editais/processo-seletivo-medicina-202701/",
			},
		},
		extravestibular: {
			titulo: "Extravestibular",
			resumo:
				"Transferência, reingresso, portador de diploma e troca de curso ou turno.",
			textoCompleto: textoExtravestibular,
			opcoes: [
				{
					id: "medicina",
					titulo: "Medicina",
					texto: textosExtra.medicina,
				},
				{
					id: "transferencia",
					titulo: "Transferência",
					texto: textosExtra.transferencia,
					href: "https://ingresso.feevale.br/?idcategoriaps=19",
				},
				{
					id: "reingresso",
					titulo: "Reingresso",
					texto: textosExtra.reingresso,
					href: "https://ingresso.feevale.br/?idcategoriaps=20",
				},
				{
					id: "portador",
					titulo: "Portador de Diploma",
					texto: textosExtra.portador,
					href: "https://ingresso.feevale.br/?idcategoriaps=18",
				},
				{
					id: "troca",
					titulo: "Troca de Curso, Turno ou Modalidade",
					texto: textosExtra.troca,
					href: "https://ingresso.feevale.br/?idcategoriaps=22",
				},
			],
		},
	},
	ead: {
		rotulo: "EAD",
		titulo: "Escolha sua forma de ingresso",
		descricao: "Veja as opções disponíveis para a graduação EAD da Feevale.",
		graduacao: {
			titulo: "Vestibular",
			resumo: "Processo seletivo para os cursos de graduação EAD.",
			textoCompleto:
				"Na modalidade EAD, o seu ingresso pode ser realizado pela prova online de redação, aproveitando suas notas da redação e prova objetiva do Enem, além de usar notas de outros processos seletivos feitos aqui.",
			acoes: [
				{
					label: "Inscreva-se",
					href: "https://ingresso.feevale.br/?idcategoriaps=24",
					principal: true,
				},
				{
					label: "Edital",
					href: "https://editais.feevale.br/editais/processo-seletivo-feevale-ead-2026/",
				},
			],
		},
		extravestibular: {
			titulo: "Extravestibular",
			resumo:
				"Transferência, reingresso, portador de diploma e troca de curso.",
			textoCompleto: textoExtravestibular,
			opcoes: [
				{
					id: "transferencia",
					titulo: "Transferência",
					texto: textosExtra.transferencia,
					href: "https://ingresso.feevale.br/?idcategoriaps=26",
				},
				{
					id: "reingresso",
					titulo: "Reingresso",
					texto: textosExtra.reingresso,
					href: "https://ingresso.feevale.br/?idcategoriaps=27",
				},
				{
					id: "portador",
					titulo: "Portador de Diploma",
					texto: textosExtra.portador,
					href: "https://ingresso.feevale.br/?idcategoriaps=25",
				},
				{
					id: "troca",
					titulo: "Troca de Curso, Turno ou Modalidade",
					texto: textosExtra.troca,
					href: "https://ingresso.feevale.br/?idcategoriaps=28",
				},
			],
		},
	},
};

const alunoEspecial = [
	{
		titulo: "Aluno Especial de outra Instituição de Ensino Superior",
		texto:
			"Consiste na possibilidade do aluno de outra instituição de ensino superior cursar componentes curriculares de seu interesse, mediante apresentação de documento de autorização da instituição de origem, constando a validação dos componentes cursados neste estabelecimento de ensino.",
	},
	{
		titulo: "Aluno Especial sem Vínculo Regular",
		texto:
			"É a possibilidade de cursar componentes curriculares isolados de graduação e aproveitá-los em um curso de graduação no qual conste o componente cursado nesta modalidade.",
	},
	{
		titulo: "Aluno Especial Ouvinte",
		texto:
			"Os acadêmicos da Universidade Feevale que desejam cursar componentes curriculares que não integram o currículo do seu curso de graduação e os interessados que não possuem vínculo com a Instituição poderão cursar componentes curriculares isolados, sempre que houver vagas, com o objetivo de atualização, desde que tenham concluído o Ensino Médio.",
	},
];

function LinkAcao({ href, children, principal = false }) {
	return (
		<a
			href={href}
			target="_blank"
			rel="noreferrer"
			className={`opcoesIngresso-btn ${
				principal
					? "opcoesIngresso-btn--principal"
					: "opcoesIngresso-btn--secundario"
			}`}
		>
			{children}
			<MDBIcon icon="arrow-right" />
		</a>
	);
}

LinkAcao.propTypes = {
	href: PropTypes.string.isRequired,
	children: PropTypes.node.isRequired,
	principal: PropTypes.bool,
};

export default function OpcoesIngresso({ modalidade }) {
	const [modalAberto, setModalAberto] = useState(false);
	const [conteudoModal, setConteudoModal] = useState({
		titulo: "",
		texto: "",
	});

	const abrirModal = (titulo, texto) => {
		setConteudoModal({ titulo, texto });
		setModalAberto(true);
	};

	const fecharModal = () => setModalAberto(false);

	if (!modalidade) {
		return (
			<section className="opcoesIngresso opcoesIngresso--vazio">
				<MDBContainer>
					<div className="opcoesIngresso-espera">
						<MDBIcon icon="hand-pointer" />
						<p>Selecione EAD ou Presencial para continuar.</p>
					</div>
				</MDBContainer>
			</section>
		);
	}

	const dados = dadosModalidade[modalidade];

	return (
		<>
			<section
				className="opcoesIngresso opcoesIngresso--ativo"
				key={modalidade}
			>
				<MDBContainer>
					<div className="opcoesIngresso-cabecalho">
						<span>{dados.rotulo}</span>
						<h2>{dados.titulo}</h2>
						<p>{dados.descricao}</p>
					</div>

					<div className="opcoesIngresso-principalGrid">
						<article className="opcoesIngresso-card opcoesIngresso-card--graduacao">
							<div className="opcoesIngresso-cardIcon">
								<MDBIcon icon="graduation-cap" />
							</div>

							<h3>{dados.graduacao.titulo}</h3>
							<p>{dados.graduacao.resumo}</p>

							<button
								type="button"
								className="opcoesIngresso-saibaMais"
								onClick={() =>
									abrirModal(
										dados.graduacao.titulo,
										dados.graduacao.textoCompleto
									)
								}
							>
								Saiba mais
								<MDBIcon icon="plus" />
							</button>

							<div className="opcoesIngresso-acoes">
								{dados.graduacao.acoes.map((acao) => (
									<LinkAcao
										key={acao.label}
										href={acao.href}
										principal={acao.principal}
									>
										{acao.label}
									</LinkAcao>
								))}
							</div>

							{dados.graduacao.medicina && (
								<div className="opcoesIngresso-medicinaVestibular">
									<h4>{dados.graduacao.medicina.titulo}</h4>
									<button
										type="button"
										className="opcoesIngresso-saibaMais opcoesIngresso-medicinaSaibaMais"
										onClick={() =>
											abrirModal(
												dados.graduacao.medicina.titulo,
												dados.graduacao.medicina.textoCompleto
											)
										}
									>
										Saiba mais
										<MDBIcon icon="plus" />
									</button>

									<div className="opcoesIngresso-medicinaAcoes">
										<LinkAcao href={dados.graduacao.medicina.href} principal>
											Portal do Inscrito
										</LinkAcao>
										<LinkAcao href={dados.graduacao.medicina.editalHref}>
											Ver edital
										</LinkAcao>
									</div>
								</div>
							)}
						</article>

						<article className="opcoesIngresso-card opcoesIngresso-card--extra">
							<div className="opcoesIngresso-cardIcon">
								<MDBIcon icon="exchange-alt" />
							</div>

							<div className="opcoesIngresso-extraHeader">
								<div>
									<h3>{dados.extravestibular.titulo}</h3>
									<p>{dados.extravestibular.resumo}</p>
								</div>

								<button
									type="button"
									className="opcoesIngresso-saibaMais opcoesIngresso-saibaMais--inline"
									onClick={() =>
										abrirModal(
											`${dados.extravestibular.titulo} - ${dados.rotulo}`,
											dados.extravestibular.textoCompleto
										)
									}
								>
									Saiba mais
									<MDBIcon icon="plus" />
								</button>
							</div>

							<div className="opcoesIngresso-extraGrid">
								{dados.extravestibular.opcoes.map((opcao) => (
									<div
										key={opcao.id}
										className="opcoesIngresso-extraItem"
									>
										<div className="opcoesIngresso-extraItemTopo">
											<strong>{opcao.titulo}</strong>
										</div>

										<div className="opcoesIngresso-extraItemAcoes">
											{opcao.href && (
												<a
													href={opcao.href}
													target="_blank"
													rel="noreferrer"
													className="opcoesIngresso-extraInscricao"
												>
													Inscreva-se
													<MDBIcon icon="arrow-right" />
												</a>
											)}

											<button
												type="button"
												className="opcoesIngresso-extraSaibaMais"
												onClick={() =>
													abrirModal(opcao.titulo, opcao.texto)
												}
											>
												Saiba mais
											</button>
										</div>
									</div>
								))}
							</div>
						</article>
					</div>

					<div className="opcoesIngresso-portal">
						<span>Já iniciou sua inscrição?</span>
						<a
							href="https://ingresso.feevale.br/login"
							target="_blank"
							rel="noreferrer"
						>
							Acessar Portal do Inscrito
							<MDBIcon icon="external-link-alt" />
						</a>
					</div>

					<details className="opcoesIngresso-alunoEspecial">
						<summary>
							<span className="opcoesIngresso-alunoEspecialResumo">
								<strong>Aluno Especial</strong>

								<span className="opcoesIngresso-alunoEspecialDescricao">
									Curse componentes curriculares mesmo sem ingressar em uma
									graduação regular.
								</span>
							</span>
						</summary>

						<div className="opcoesIngresso-alunoEspecialConteudo">
							{alunoEspecial.map((item) => (
								<div
									className="opcoesIngresso-alunoEspecialItem"
									key={item.titulo}
								>
									<h4>{item.titulo}</h4>
									<p>{item.texto}</p>
								</div>
							))}

							<a
								href="https://www.feevale.br/institucional/fale-com-a-feevale"
								target="_blank"
								rel="noreferrer"
								className="opcoesIngresso-alunoEspecialLink"
							>
								Saiba mais sobre Aluno Especial
								<MDBIcon icon="arrow-right" />
							</a>
						</div>
					</details>
				</MDBContainer>
			</section>

			<MDBModal
				isOpen={modalAberto}
				toggle={fecharModal}
				centered
				className="opcoesIngresso-modal"
			>
				<MDBModalHeader toggle={fecharModal}>
					{conteudoModal.titulo}
				</MDBModalHeader>

				<MDBModalBody>
					<p className="opcoesIngresso-modalTexto">
						{conteudoModal.texto}
					</p>
				</MDBModalBody>
			</MDBModal>
		</>
	);
}

OpcoesIngresso.propTypes = {
	modalidade: PropTypes.oneOf(["presencial", "ead"]),
};
